import fixtureData from "../localData/fixtureData.json";
import { getFixtureDate } from "../utilities";

// Move these into something like GET_FIXTURE_SUCCESS reducer when API hooked up
// enhancedFixtureData
// uniqueFixtureDates
// groupedFixturesByDay

const enhancedFixtureData = {
  ...fixtureData,
  items: fixtureData.items.map((item) => ({
    ...item,
    fixtureDate: getFixtureDate(item.fixture_start_date_time),
  })),
};

const uniqueFixtureDates = enhancedFixtureData.items
  .map((fixture) => fixture.fixtureDate)
  .filter(
    (date, i, self) =>
      self.findIndex((d) => d.getTime() === date.getTime()) === i,
  );

const groupedFixturesByDay = uniqueFixtureDates.map((date) => ({
  date,
  items: enhancedFixtureData.items.filter(
    (fixture) => fixture.fixtureDate.getTime() === date.getTime(),
  ),
}));

const initState = {
  ...enhancedFixtureData,
  uniqueFixtureDates,
  fixtureFilteredBy: uniqueFixtureDates[0],
  groupedFixturesByDay,
};

const fixtures = (state = initState, action) => {
  switch (action.type) {
    case "SET_FIXTURE_DATE_FILTER":
      return {
        ...state,
        fixtureFilteredBy: action.date,
      };
    default:
      return state;
  }
};
export default fixtures;
